// import React, { useState, useEffect, useRef } from "react";
// import { Button, Checkbox, Input } from "antd";
// import "../auth-common.css";
// import "./login.css";
// import Cookies from "js-cookie";
// import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
// import { useNavigate, Link, useLocation } from "react-router-dom";
// import { ErrorToast, SuccessToast } from "../../widgets/AppToast";
// import { post } from "../../services/services";
// import { ApiURL } from "../../services/apiConstants";

// const Login = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [rememberMe, setRememberMe] = useState(false);
//   const [loader, setLoader] = useState(false);
//   const [errors, setErrors] = useState({});
//   const loginButtonRef = useRef(null);

//   const handleKeyDown = (event) => {
//     if (event.key === "Enter") {
//       event.preventDefault();
//       loginButtonRef.current.click();
//     }
//   };

//   useEffect(() => {
//     const savedEmail = Cookies.get("email");
//     const savedPassword = Cookies.get("password");
//     const savedPath = Cookies.get("path");
//     if (savedPath === location.pathname) {
//       setEmail(savedEmail || "");
//       setPassword(savedPassword || "");
//       setRememberMe(true);
//     }
//   }, [location.pathname]);

//   const login = async () => {
//     if (loader) return;
//     setLoader(true);
//     try {
//       const formData = new FormData();
//       formData.append("email", email);
//       formData.append("password", password);
//       const res = await post(ApiURL.login, formData);
//       if (res?.status === true) {
//         const { login_token, refresh_token, role } = res?.data;
//         localStorage.setItem("user_data", JSON.stringify(res));
//         localStorage.setItem("login_token", login_token);
//         localStorage.setItem("refresh_token", refresh_token);
//         localStorage.setItem("role", role);
//         SuccessToast("Success message!!", res?.message);
//         if (rememberMe) {
//           Cookies.set("email", email);
//           Cookies.set("password", password);
//         } else {
//           Cookies.remove("email");
//           Cookies.remove("password");
//         }
//         window.location = "/";
//       } else {
//         if (res?.resent_otp) {
//           navigate("/otp-verification/" + btoa(email) + "/" + btoa("registration"));
//         }
//         setErrors(res?.errors || {});
//         ErrorToast("Login Error", res?.message || "Both email and password are required");
//       }
//     } catch (error) {
//       ErrorToast("Login error", "An error occurred during login!");
//     } finally {
//       setLoader(false);
//     }
//   };

//   return (
//     <div className="auth-page-container">
//       <div className="auth-glass-card">
//         <div className="auth-header">
//           <h5>MarinBytes - Data, Ships, People and Sustainability</h5>
//           <h2>Login</h2>
//         </div>
//         <div className="auth-body">
//           <div className="auth-input-group">
//             <label>Email Address</label>
//             <Input
//               size="large"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               autoComplete="off"
//               onKeyDown={handleKeyDown}
//             />
//             {errors?.email && <span style={{ color: "red", fontSize: "12px" }}>{errors.email}</span>}
//           </div>
//           <div className="auth-input-group">
//             <label>Password</label>
//             <Input.Password
//               size="large"
//               placeholder="Enter your password"
//               autoComplete="new-password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               onKeyDown={handleKeyDown}
//               iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
//             />
//             {errors?.password && <span style={{ color: "red", fontSize: "12px" }}>{errors.password}</span>}
//           </div>
          
//           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//             <Checkbox
//               checked={rememberMe}
//               onChange={(e) => setRememberMe(e.target.checked)}
//             >
//               Remember me
//             </Checkbox>
//             <span
//               className="auth-link-btn"
//               style={{ fontSize: "14px" }}
//               onClick={() => navigate("/reset-password")}
//             >
//               Forgot Password?
//             </span>
//           </div>

//           <Button
//             className="auth-primary-btn"
//             type="primary"
//             onClick={login}
//             loading={loader}
//             ref={loginButtonRef}
//           >
//             Login
//           </Button>
//         </div>
        
//         <div style={{ marginTop: "30px", textAlign: "center", borderTop: "1px solid rgba(0,0,0,0.1)", paddingTop: "20px" }}>
//           <span style={{ fontSize: "15px", color: "#555" }}>
//             Don't have an account?{" "}
//             <Link className="auth-link-btn" to="/registration">
//               Sign up
//             </Link>
//           </span>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;


import React, { useState, useEffect, useRef } from "react";
import { Button, Checkbox, Input } from "antd";
import "../auth-common.css";
import "./login.css";
import Cookies from "js-cookie";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../widgets/AppToast";
import { post } from "../../services/services";
import { ApiURL } from "../../services/apiConstants";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const loginButtonRef = useRef(null);

  const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      loginButtonRef.current.click();
    }
  };

  useEffect(() => {
    const savedEmail = Cookies.get("email");
    const savedPassword = Cookies.get("password");
    const savedPath = Cookies.get("path");
    if (savedPath === location.pathname) {
      setEmail(savedEmail || "");
      setPassword(savedPassword || "");
      setRememberMe(true);
    }
  }, [location.pathname]);

  const login = async () => {

      let validationErrors = {};

  if (!email) {
    validationErrors.email = "Please enter email address";
  } else if (!validateEmail(email)) {
    validationErrors.email = "Enter a valid email address";
  }

  if (!password) {
    validationErrors.password = "Please provide a password";
  }

  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

    if (loader) return;
    setLoader(true);
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password", password);
      const res = await post(ApiURL.login, formData);
      if (res?.status === true) {
        const { login_token, refresh_token, role } = res?.data;
        localStorage.setItem("user_data", JSON.stringify(res));
        localStorage.setItem("login_token", login_token);
        localStorage.setItem("refresh_token", refresh_token);
        localStorage.setItem("role", role);
        SuccessToast("Success message!!", res?.message);
        if (rememberMe) {
          Cookies.set("email", email);
          Cookies.set("password", password);
        } else {
          Cookies.remove("email");
          Cookies.remove("password");
        }
        window.location = "/";
      } else {
        if (res?.resent_otp) {
          navigate("/otp-verification/" + btoa(email) + "/" + btoa("registration"));
        }
        setErrors(res?.errors || {});
        ErrorToast("Login Error", res?.message || "Both email and password are required");
      }
    } catch (error) {
      ErrorToast("Login error", "An error occurred during login!");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-glass-card">
        <div className="auth-header">
          <h5>MarinBytes - Data, Ships, People and Sustainability</h5>
          <h2>Login</h2>
        </div>
        <div className="auth-body">
          <div className="auth-input-group">
            <label>Email Address</label>
            {/* <Input
              size="large"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="off"
              onKeyDown={handleKeyDown}
            /> */}

            {/* <Input
  size="large"
  placeholder="Enter your email"
  value={email}
  onChange={(e) => {
    setEmail(e.target.value);
    setErrors({ ...errors, email: "" });
  }}
  autoComplete="off"
  onKeyDown={handleKeyDown}
/> */}

<Input
  size="large"
  placeholder="Enter your email"
  value={email}
  onChange={(e) => {
    const value = e.target.value;
    setEmail(value);

    let error = "";

    if (!value) {
      error = "Email address is required";
    } else if (!validateEmail(value)) {
      error = "Enter a valid email address";
    }

    setErrors((prev) => ({ ...prev, email: error }));
  }}
  autoComplete="off"
  onKeyDown={handleKeyDown}
/>
            {errors?.email && <span style={{ color: "red", fontSize: "12px" }}>{errors.email}</span>}
          </div>
          <div className="auth-input-group">
            <label>Password</label>
            {/* <Input.Password
              size="large"
              placeholder="Enter your password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            /> */}
            {/* <Input.Password
  size="large"
  placeholder="Enter your password"
  autoComplete="new-password"
  value={password}
  onChange={(e) => {
    setPassword(e.target.value);
    setErrors({ ...errors, password: "" });
  }}
  onKeyDown={handleKeyDown}
  iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
/> */}
<Input.Password
  size="large"
  placeholder="Enter your password"
  autoComplete="new-password"
  value={password}
  onChange={(e) => {
    const value = e.target.value;
    setPassword(value);

    let error = "";

    if (!value) {
      error = "Password is required";
    }

    setErrors((prev) => ({ ...prev, password: error }));
  }}
  onKeyDown={handleKeyDown}
  iconRender={(visible) =>
    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
  }
/>
            {errors?.password && <span style={{ color: "red", fontSize: "12px" }}>{errors.password}</span>}
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <Checkbox
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            >
              Remember me
            </Checkbox>
            <span
              className="auth-link-btn"
              style={{ fontSize: "14px" }}
              onClick={() => navigate("/reset-password")}
            >
              Forgot Password?
            </span>
          </div>

          <Button
            className="auth-primary-btn"
            type="primary"
            onClick={login}
            loading={loader}
            ref={loginButtonRef}
          >
            Login
          </Button>
        </div>
        
        <div style={{ marginTop: "30px", textAlign: "center", borderTop: "1px solid rgba(0,0,0,0.1)", paddingTop: "20px" }}>
          <span style={{ fontSize: "15px", color: "#555" }}>
            Don't have an account?{" "}
            <Link className="auth-link-btn" to="/registration">
              Sign up
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Login;
